var map = {
	"./BFG.svg": "5822",
	"./BG terrazzo vanilla.svg": "e6ac",
	"./BGblue.svg": "a4dc",
	"./BGorange.svg": "b143",
	"./BGred.svg": "92c0",
	"./BGvanilla.svg": "0a57",
	"./BackButton.svg": "f898",
	"./Bg-White.svg": "b349",
	"./CMB.svg": "55cc",
	"./MainPhoneBackground.svg": "83aa",
	"./MenuBackground.svg": "74d0",
	"./stripes.svg": "6c33",
	"./the-ambassador.svg": "3a5b",
	"./the-artist.svg": "7cb8",
	"./the-cheerleader.svg": "30e2",
	"./the-dj.svg": "06c7",
	"./the-judge.svg": "effd",
	"./the-lion-tamer-v2.svg": "3d22",
	"./the-lion-tamer.svg": "4012",
	"./the-mad-scientist.svg": "4846",
	"./the-professional-footballer.svg": "74c8",
	"./the-scout-leader.svg": "f60b",
	"./white-spots.svg": "8fc6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afd2";